import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Wordmark } from "@/components/Logo";
import ContactModal from "@/components/ContactModal";

const nav = [
  { label: "Platform", href: "#platform" },
  { label: "Products", href: "#products" },
  { label: "Case Studies", href: "#cases" },
  { label: "Architecture", href: "#architecture" },
  { label: "Engagement", href: "#engagement" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [openContact, setOpenContact] = useState(false);
  const loc = useLocation();
  const isDemo = loc.pathname.startsWith("/demo");

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 12);
    on();
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
          scrolled || isDemo
            ? "backdrop-blur-xl bg-[#0B1021]/80 border-b border-white/5"
            : "bg-transparent"
        }`}
        data-testid="site-navbar"
      >
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
          <Link to="/" data-testid="nav-home-link">
            <Wordmark />
          </Link>
          {!isDemo && (
            <nav className="hidden md:flex items-center gap-8">
              {nav.map((n) => (
                <a
                  key={n.label}
                  href={n.href}
                  className="text-sm text-slate-300 hover:text-white transition-colors"
                  data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {n.label}
                </a>
              ))}
            </nav>
          )}
          <div className="flex items-center gap-3">
            <span className="hidden lg:inline tech-label" data-testid="market-badge">US · CA</span>
            {isDemo ? (
              <Link
                to="/"
                className="px-4 py-2 rounded-md text-sm btn-ghost"
                data-testid="back-to-site"
              >
                Back to Site
              </Link>
            ) : (
              <>
                <Link
                  to="/demo/commercial"
                  className="hidden sm:inline-block px-4 py-2 rounded-md text-sm btn-ghost"
                  data-testid="nav-explore-demo"
                >
                  Explore Demo
                </Link>
                <button
                  onClick={() => setOpenContact(true)}
                  className="px-4 py-2 rounded-md text-sm btn-primary"
                  data-testid="nav-contact-cta"
                >
                  Contact
                </button>
              </>
            )}
          </div>
        </div>
      </header>
      <ContactModal open={openContact} onOpenChange={setOpenContact} />
    </>
  );
}
